import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiClientInterface } from '../../client/api/api-client.interface';
import { ClientInterface, ClientNotificationInterface, ContractInterface, DocumentType, ValidationClient } from '../data';
import { Transaction } from '../transaction/transaction';
import { TransactionRequestInterface } from '../transaction/transaction-request.interface';

@Injectable()
export class ClientApiRepository {
    constructor(private apiClient: ApiClientInterface, private transactionRequest: TransactionRequestInterface) {}

    load(docType: DocumentType, docId: string): Observable<Transaction<ClientInterface>> {
        return this.transactionRequest.wrap(this.apiClient.getClientByDocumentId(docType, docId));
    }

    reject(contract: ContractInterface, client: ClientInterface, message: string): Observable<Transaction<void>> {
        return new Observable((observer) => {
            this.transactionRequest
                .wrap(this.apiClient.rejectClient(contract.encryptedCode, client.encryptedCode, message))
                .subscribe((transaction) => {
                    if (transaction.isSuccess) {
                        observer.next(Transaction.success());
                    } else {
                        observer.next(Transaction.error(transaction.error));
                    }

                    observer.complete();
                });
        });
    }

    revise(contract: ContractInterface, client: ClientInterface, message: string): Observable<Transaction<void>> {
        return new Observable((observer) => {
            this.transactionRequest
                .wrap(this.apiClient.reviseClient(contract.encryptedCode, client.encryptedCode, message))
                .subscribe((transaction) => {
                    if (transaction.isSuccess) {
                        observer.next(Transaction.success());
                    } else {
                        observer.next(Transaction.error(transaction.error));
                    }

                    observer.complete();
                });
        });
    }

    validate(client: ClientInterface): Observable<Transaction<void>> {
        return new Observable((observer) => {
            this.transactionRequest.wrap(this.apiClient.validateClient(client.encryptedCode)).subscribe((transaction) => {
                if (transaction.isSuccess) {
                    observer.next(Transaction.success());
                } else {
                    observer.next(Transaction.error(transaction.error));
                }

                observer.complete();
            });
        });
    }

    validateData(client: ClientInterface, validations: ValidationClient[]): Observable<Transaction<void>> {
        return new Observable((observer) => {
            this.transactionRequest.wrap(this.apiClient.validateClientData(client.encryptedCode, validations)).subscribe((transaction) => {
                if (transaction.isSuccess) {
                    observer.next(Transaction.success());
                } else {
                    observer.next(Transaction.error(transaction.error));
                }

                observer.complete();
            });
        });
    }

    validateNotifications(): Observable<Transaction<ClientNotificationInterface[]>> {
        return this.transactionRequest.wrap(this.apiClient.getValidateClientNotifications());
    }
}
